const $ = jQuery

class StripeForMembership {
	constructor() {
		if (typeof window.schemeRegistrationAjax === 'undefined' ||
			typeof window.schemeRegistrationAjax.stripe_key === 'undefined' ||
			window.schemeRegistrationAjax.stripe_key === null) {

			throw 'Missing stripe_key'
		}

		this.$form = null
		this.cardElement = null
		this.member = null
		this.userEmail = ''
		this.stripeCardSelector = '#stripe-card-container'
		this.$emailField = $('.js-scheme__field--email')
		this.$verificationFieldWrapper = $('.js-scheme__verificationFieldWrapper')
		this.$verificationField = $('.js-scheme__field--verification')
		this.$redeemedOfferErrorBox = $('.js-scheme__errorBox--redeemed')
		this.partnerSchemeForm = $('.js-scheme__form').find('form').attr('data-scheme-type') === 'partner'
		this.hotelSchemeForm = $('.js-scheme__form').find('form').attr('data-scheme-type') === 'hotel'

		if (this.requiresPayment()) {
			this.stripe = Stripe(window.schemeRegistrationAjax.stripe_key, {
				apiVersion: '2020-03-02',
			})
			this.stripeInErrorState = false
		}

		this.initFieldListeners()
	}

	requiresPayment = () => {
		return $(this.stripeCardSelector).length !== 0
	}

	getCampaignId = () => {
		const $campaignInput = this.$form.find('input[name="campaign_id"]');
		return $campaignInput.length ? $campaignInput.val() : null;
	}

	getPriceId = () => {
		const $priceInput = this.$form.find('input[name="price_id"]:checked');
		return $priceInput.val();
	}

	getPriceType = () => {
		const $priceInput = this.$form.find('input[name="price_id"][value="' + this.getPriceId() +'"]')
		let $priceTypeInput

		if ($priceInput.attr('id') === 'price_1') {
			$priceTypeInput = this.$form.find('input[name="price_type"]')
		} else {
			$priceTypeInput = this.$form.find('input[name="price_type_2"]')
		}

		if (! $priceTypeInput.length) {
			return 'recurring'
		}

		return $priceTypeInput.val()
	}

	getSchemeId = () => {
		const $schemeIdInput = this.$form.find('input[name="scheme_id"]');
		return $schemeIdInput.length ? $schemeIdInput.val() : null;
	}

	getSchemeType = () => {
		const $schemeTypeInput = this.$form.find('input[name="scheme_type"]');
		return $schemeTypeInput.length ? $schemeTypeInput.val() : null;
	}

	createPaymentMethod = ({campaignId, card, isPaymentRetry, invoiceId, member}) => {
		this.addLoadingIndicator()

		this.stripe
			.createPaymentMethod({
				type: 'card',
				card: card,
				billing_details: {
					name: member.firstName + ' ' + member.lastName,
				},
			})
			.then((result) => {
				if (result.error) {
					this.showCardError(result.error.message)
				} else {
					if (isPaymentRetry) {
						// @todo Update the payment method and retry invoice payment
					} else {
						const data = {
							campaignId: this.getCampaignId(),
							member: member,
							paymentMethodId: result.paymentMethod.id,
							priceId: this.getPriceId(),
							schemeId: this.getSchemeId(),
							schemeType: this.getSchemeType(),
						}

						switch (this.getPriceType()) {
							case 'one_time':
								this.createPaymentIntent(data)
								break

							case 'recurring':
								this.createSubscription(data)
								break
						}
					}
				}
			})
	}

	handlePaymentThatRequiresCustomerAction = (data) => {
		const {invoice, paymentMethodId, subscription, isRetry} = data

		if (subscription && subscription.status === 'active') {
			// Subscription is active, no customer actions required.
			return data
		}

		// If it's a first payment attempt, the payment intent is on the subscription latest invoice.
		// If it's a retry, the payment intent will be on the invoice itself.
		let paymentIntent = invoice ? invoice.payment_intent : subscription.latest_invoice.payment_intent

		if (
			paymentIntent.status === 'requires_action' ||
			paymentIntent.status === 'requires_source_action' ||
			(isRetry === true && paymentIntent.status === 'requires_payment_method') ||
			(isRetry === true && paymentIntent.status === 'requires_source')
		) {
			return this.stripe
				.confirmCardPayment(paymentIntent.client_secret, {
					payment_method: paymentMethodId,
				})
				.then((result) => {
					if (result.error) {
						throw {
							data: result,
						}
					} else {
						if (result.paymentIntent.status === 'succeeded') {
							return data
						} else {
							throw {
								data: {
									error: {
										message: 'Payment authentication did not complete. Please try again.',
									},
								},
							}
						}
					}
				})
		} else {
			// No customer action needed.
			return data
		}
	}

	handleRequiresPaymentMethod = (data) => {
		const {subscription} = data

		if (subscription.status === 'active') {
			// subscription is active, no customer actions required.
			return data
		} else if (
			subscription.latest_invoice.payment_intent.status === 'requires_payment_method' ||
			subscription.latest_invoice.payment_intent.status === 'requires_source'
		) {
			throw {error: {message: 'Your card was declined.'}}
		} else {
			return data
		}
	}

	allowResubmit = () => {
		this.$form.find('button[type="submit"]').prop('disabled', false)
		this.removeLoadingIndicator()
	}

	disableForm = () => {
		this.$form.find('button[type="submit"]').prop('disabled', true)
	}

	showCardError = (error) => {
		this.allowResubmit()

		this.$form.find('#stripe-card-errors').text(error)
	}

	showError = (error) => {
		this.allowResubmit()

		const $errorBox = this.$form.find('.c-scheme__formErrorBox')

		$errorBox
			.removeClass('c-scheme__formErrorBox--friendly')
			.removeClass('is-hidden')

		if (error === 'Membership already active.') {
			$errorBox
				.addClass('c-scheme__formErrorBox--friendly')
				.html('<p>You are already a member of the Luxury Restaurant Club or one of our partner hotel clubs. Please contact a member of our Service Team to assist.</p>')
		} else {
			$errorBox.text(error)
		}
	}

	clearErrors = () => {
		this.$form.find('#stripe-card-errors').text('')

		this.$form.find('.c-scheme__formErrorBox')
			.addClass('is-hidden')
			.text('')
	}

	showFieldErrors = (field, errors) => {
		const $input = this.$form.find(':input[name="' + field + '"]')

		if (!$input.length) {
			return false
		}

		$input.addClass('is-invalid')

		let $feedback = $input.next('.invalid-feedback')

		if (!$feedback.length) {
			$feedback = $('<span class="invalid-feedback" role="alert"></span>')
			$input.after($feedback)
		}

		$feedback.children().detach()
		errors.forEach(error => $feedback.append('<p>' + error + '</p>'))

		return true
	}

	clearFieldErrors = () => {
		this.$form.find(':input').removeClass('is-invalid')
		this.$form.find('.invalid-feedback').detach()
	}

	assignScheme = ({campaignId, member, schemeId, schemeType}) => {
		const formData = new FormData()
		formData.set('action', 'assign_scheme_to_member')
		formData.set('email', member.email)
		formData.set('campaignId', campaignId)
		formData.set('customerId', member.stripeCustomerId)

		if (schemeId !== null && schemeType !== null) {
			formData.set('schemeId', schemeId)
			formData.set('schemeType', schemeType)
		}

		this.addLoadingIndicator()

		fetch(window.schemeRegistrationAjax.ajax_url, {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then((response) => {
				if (!response.success) {
					throw response
				}

				return response
			})
			.then(this.onSubscriptionComplete)
			.catch((error) => {
				console.error(error);
				const {code, data} = error

				if (typeof data.message !== 'undefined') {
					this.showError(error.data.message)
				} else if (typeof code === 'undefined') {
					this.showError('Sorry, we are unable to process your registration at this time. (E1)');
				}

				this.allowResubmit()
			})
	}

	createPaymentIntent = ({campaignId, member, paymentMethodId, priceId, schemeId, schemeType}) => {
		const formData = new FormData()
		formData.set('action', 'create_payment_intent')
		formData.set('email', member.email)
		formData.set('campaignId', campaignId)
		formData.set('customerId', member.stripeCustomerId)
		formData.set('paymentMethodId', paymentMethodId)
		formData.set('priceId', priceId)

		if (schemeId !== null && schemeType !== null) {
			formData.set('schemeId', schemeId)
			formData.set('schemeType', schemeType)
		}

		fetch(window.schemeRegistrationAjax.ajax_url, {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then(response => {
				if (!response.success) {
					throw response
				}

				this.paymentIntent = response.data

				this.stripe.confirmCardPayment(response.data.client_secret, {
					payment_method: {
						card: this.cardElement,
						billing_details: {
							name: member.firstName + ' ' + member.lastName,
						}
					}
				}).then(result => {
					if (result.error) {
						this.showCardError(result.error.message)
					} else {
						if (result.paymentIntent.status === 'succeeded') {
							this.onSubscriptionComplete()
						}
					}
				});
			})
		.catch((error) => {
			console.error(error);
			const {code, data} = error ?? {}

			if (data?.error !== undefined) {
				this.showCardError(data.error.message)
			} else if (data?.message !== undefined) {
				this.showError(data.message)
			} else if (typeof code === 'undefined') {
				this.showError('Sorry, we are unable to process your registration at this time. (E2)')
			}

			this.allowResubmit()
		})
	}

	createSubscription = ({campaignId, member, paymentMethodId, priceId, schemeId, schemeType}) => {
		const formData = new FormData()
		formData.set('action', 'create_subscription_for_member')
		formData.set('email', member.email)
		formData.set('campaignId', campaignId)
		formData.set('customerId', member.stripeCustomerId)
		formData.set('paymentMethodId', paymentMethodId)
		formData.set('priceId', priceId)

		if (schemeId !== null && schemeType !== null) {
			formData.set('schemeId', schemeId)
			formData.set('schemeType', schemeType)
		}

		this.addLoadingIndicator()

		fetch(window.schemeRegistrationAjax.ajax_url, {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then((response) => {
				if (!response.success) {
					throw response
				}

				return response
			})
			.then((response) => {
				// Normalise for the following steps
				return {
					campaignid: campaignId,
					member: member,
					paymentMethodId: paymentMethodId,
					priceId: priceId,
					subscription: response.data,
					schemeId: schemeId,
					schemeType: schemeType,
				}
			})
			.then(this.handlePaymentThatRequiresCustomerAction)
			.then(this.handleRequiresPaymentMethod)
			.then(this.onSubscriptionComplete)
		.catch((error) => {
			console.error(error)
			const {code, data} = error ?? {}

			if (data?.error !== undefined) {
				this.showCardError(data.error.message)
			} else if (data?.message !== undefined) {
				this.showError(data.message)
			} else if (typeof code === 'undefined') {
				this.showError('Sorry, we are unable to process your registration at this time. (E3)')
			}

			this.allowResubmit()
		})
	}

	onSubscriptionComplete = (data) => {
		const $completed = $('<input type="hidden" name="completed" value="1">')
		this.$form.append($completed)

		this.$form.unbind('submit', this.formSubmitHandler)
		this.$form.submit()
	}

	addLoadingIndicator = () => {
		setTimeout(() => {
			if ( $('.js-loginModal__spinner').length ) return
			this.$form.append('<div class="c-loginModal__spinner js-loginModal__spinner l-spinner"><div class="l-spinner__el"></div></div>')
			const $submitButton = this.$form.find('button[type="submit"]')
			$submitButton.text('Please wait...')
		}, 10)
	}

	removeLoadingIndicator = () => {
		const $submitButton = this.$form.find('button[type="submit"]')
		$submitButton.text('Submit')
		$('.js-loginModal__spinner').remove()
	}

	scrollToFirstFieldError = () => {
		const $firstErr = this.$form.find('.invalid-feedback').first()

		if ($firstErr) {
			const $header = $('.c-header');
			let headerOffset = 0

			if ($header.length && $header.css('position') === 'fixed') {
				headerOffset = $header.outerHeight()
			}

			$('html, body').animate({
				scrollTop: $firstErr.offset().top -
					($firstErr.height() * 2) -
					headerOffset,
			}, 500)
		}
	}

	createMember = (formDataString) => {
		const formData = new FormData()
		formData.set('action', this.requiresPayment() ?
			'register_member_with_customer' : 'register_member')
		formData.set('formData', formDataString)

		this.addLoadingIndicator()

		fetch(window.schemeRegistrationAjax.ajax_url, {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then((response) => {
				if (!response.success) {
					throw response
				}

				this.member = response.data

				if (this.requiresPayment()) {
					this.createPaymentMethod({
						member: response.data,
						card: this.cardElement,
					})
				} else {
					this.assignScheme({
						campaignId: this.getCampaignId(),
						member: response.data,
						schemeId: this.getSchemeId(),
						schemeType: this.getSchemeType(),
					})
				}
			})
			.catch((error) => {
				console.error(error)

				if (typeof error.code === 'undefined') {
					this.showError('Sorry, we are unable to process your registration at this time. (E4)');
					this.allowResubmit()

					return;
				}

				if (typeof error.data.errors !== 'undefined') {
					Object.entries(error.data.errors).forEach(([field, errors]) => {
						if (!this.showFieldErrors(field, errors)) {
							errors.forEach(this.showError)
						}
					})

					this.scrollToFirstFieldError()
				}

				this.allowResubmit()
			})
	}

	updateMemberDetails = (formDataString) => {
		const formData = new FormData()
		formData.set('action', 'update_member_details')
		formData.set('formData', formDataString)

		this.addLoadingIndicator()

		fetch(window.schemeRegistrationAjax.ajax_url, {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then((response) => {
				if (!response.success) {
					throw response
				}

				this.member = response.data
			})
			.then(this.createCustomer)
			.then(() => {
				if (this.requiresPayment()) {
					this.createPaymentMethod({
						member: this.member,
						card: this.cardElement,
					})
				} else {
					this.assignScheme({
						campaignId: this.getCampaignId(),
						member: this.member,
						schemeId: this.getSchemeId(),
						schemeType: this.getSchemeType(),
					})
				}
			})
			.catch((error) => {
				console.error(error)

				if (typeof error.code === 'undefined') {
					this.showError('Sorry, we are unable to process your registration at this time. (E5)');
					this.allowResubmit()

					return;
				}

				if (typeof error.data.errors !== 'undefined') {
					Object.entries(error.data.errors).forEach(([field, errors]) => {
						if (!this.showFieldErrors(field, errors)) {
							errors.forEach(this.showError)
						}
					})

					this.scrollToFirstFieldError()
				}

				this.allowResubmit()
			})
	}

	createCustomer = () => {
		if (typeof this.member.stripeCustomerId === 'string') {
			return Promise.resolve()
		}

		const formData = new FormData()
		formData.set('action', 'create_customer')
		formData.set('email', this.member.email)

		return fetch(window.schemeRegistrationAjax.ajax_url, {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then((response) => {
				if (!response.success) {
					throw response
				}

				this.member.stripeCustomerId = response.data
			})
	}

	formSubmitHandler = (e) => {
		e.preventDefault()

		this.clearErrors()
		this.clearFieldErrors()

		if (this.requiresPayment() && !this.stripeComplete()) {
			this.showCardError('Please check your payment details.')
			return
		}

		this.$form.find('button[type="submit"]').prop('disabled', true)

		if (this.member) {
			this.updateMemberDetails($(e.target).serialize())
		} else {
			this.createMember($(e.target).serialize())
		}
	}

	stripeComplete = () => {
		if (this.stripeInErrorState) {
			return false
		}

		return document.querySelector(this.stripeCardSelector).classList.contains('StripeElement--complete')
	}

	formPostRender = () => {
		if (this.requiresPayment()) {
			const elements = this.stripe.elements()
			this.cardElement = elements.create('card')
			this.cardElement.mount(this.stripeCardSelector)
			this.cardElement.on('change', function(event) {
				this.stripeInErrorState = !!event.error
			});
		}

		this.$form = $('.js-scheme__form').find('form').addBack('form')

		this.$form.unbind('submit', this.formSubmitHandler)
		this.$form.on('submit', this.formSubmitHandler)
	}

	initFieldListeners = () => {
		this.$emailField.on('input', (e) => {
			const value = e.target.value
			let isValid = true

			this.$emailField.each(function() {
				const fieldValue = $(this).val()

				if (value !== fieldValue) {
					isValid = false
				}
			})

			if (isValid) {

				const payload = {
					email: value
				}

				if (this.partnerSchemeForm || this.hotelSchemeForm) {
					payload.campaignId = this.getCampaignId()
				}

				this.$redeemedOfferErrorBox.addClass('d-none')
				this.$redeemedOfferErrorBox.html('')

				$.post(`${API_BASE_URL}/v2/verify`, payload, data => {

					if (data.must_verify) {
						this.$verificationFieldWrapper.removeClass('d-none')
						this.$verificationField.attr('required', true)

						this.disableForm()
					}
				}).fail((err) => {
					const errMessage = err?.responseJSON?.error
					if (errMessage === 'Membership already active.' || errMessage === 'One-time offer cannot be re-registered.') {
						this.$redeemedOfferErrorBox.removeClass('d-none')

						// prod || staging
						if (this.getCampaignId() === '7014I000000BtAQ' || this.getCampaignId() === '7014I000000ZUH6') {
							this.$redeemedOfferErrorBox.html(`
								<h4>Offer already redeemed</h4>
								This email address has already been used to redeem the complimentary one-time offer. A further year of membership is available for just £30 (RRP £95) <a href="/offers/Annual-Membership-in-association-with-The-Telegraph">here</a>.
							`)
						} else if (errMessage === 'One-time offer cannot be re-registered.') {
							this.$redeemedOfferErrorBox.html(`
								<h4>Offer already redeemed</h4>
								This email address has already been used to redeem this one-time offer.
							`)
						} else {
							this.$redeemedOfferErrorBox.html(`
								<h4>Offer already redeemed</h4>
								This offer has been redeemed and is active.
							`)
						}

						this.disableForm()
					}
				})
			} else {
				this.$verificationFieldWrapper.addClass('d-none')
				this.$verificationField.attr('required', false)
				this.allowResubmit()
			}

			// Store last user email value for 5 digit code verification
			this.userEmail = $('.js-scheme__field--emailMain').val()
		})

		this.$verificationField.on('input', (e) => {
			const value = e.target.value

			// 5 as verification code has 5 digits
			if (value.length === 5) {
				$.post(`${API_BASE_URL}/v2/verify/${value}`, { email: this.userEmail }, data => {

					this.member = data
					this.allowResubmit()

					$('.js-scheme__errorBox--verification').addClass('d-none')
					$('.js-scheme__verificationFieldError').text('')

				}).fail(() => {
					$('.js-scheme__verificationFieldError').text('Please check the verification code has been entered correctly below and click submit.')
					$('.js-scheme__errorBox--verification').removeClass('d-none')
				})
			}
		})
	}
}

const stripeForMembership = new StripeForMembership
$(document).ready(function () {
	stripeForMembership.formPostRender()
})
